export const linking = {
  prefixes: ["/"],
  config: {
    screens: {
      lead: "lead",
      wholesaler: "wholesaler",

      insert_mobile: "auth/login",
      verify_code: "auth/verify-code",

      home: "",
      cart: "cart",
      orders: "orders",
      profile: "profile",
      about_us: "about_us",
      register: "register",
      category: "category",
      products: "products",
      contact_us: "contact_us",
      order_details: "order_details",
    },
  },
};
